import { baseRequest } from '@/lib/base';

export interface ApiNotification {
    id: number;
    kind: 'connection_request' | 'connection_accepted'
        | 'connection_rejected' | 'announcement_created'
        | 'quotation_requested' | 'quotation_responded'
        | 'order_updated' | 'order_accepted' | 'order_declined'
        | 'order_created' | 'order_modified' | 'order_cancelled'
        | 'order_confirmed' | 'order_completed'
        | (string & Record<never, never>);
    title: string;
    body: string;
    payload: unknown;
    is_read: boolean;
    read_at: string | null;
    actor: {
        id: number;
        username: string;
        business_name: string | null;
    };
    created_at: string;
    updated_at: string;
}

// Order notifications carry the order's uuid under one of a few payload
// shapes depending on the event; this centralizes the lookup.
export function getNotificationOrderUuid(n: ApiNotification): string | undefined {
    const payload = n.payload as Record<string, unknown> | null | undefined;
    const order = payload?.order as Record<string, unknown> | undefined;
    const uuid = payload?.uuid ?? payload?.order_uuid ?? order?.uuid;
    return typeof uuid === 'string' ? uuid : undefined;
}

export const fetchNotifications = (
    params: { page?: number; page_size?: number } = {},
) => {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) sp.set(key, String(value));
    });
    const qs = sp.toString();
    return baseRequest({
        url: `/system/notifications/${qs ? `?${qs}` : ''}`,
    });
};

export const fetchUnreadCount = () => baseRequest({
    url: '/system/notifications/unread-count/',
});

export const markNotificationRead = (id: number) => baseRequest({
    url: `/system/notifications/${id}/read/`,
    method: 'PATCH',
    body: { is_read: true },
});

export const markAllNotificationsRead = () => baseRequest({
    url: '/system/notifications/read-all/',
    method: 'PATCH',
});

export const deleteNotification = (id: number) => baseRequest({
    url: `/system/notifications/${id}/`,
    method: 'DELETE',
});
